import { upload } from '@client/components/ajax';

type BannerImageModelParams = {
  creatorId: number;
};

export const useFileUploadModel = (p: BannerImageModelParams) => {
  const uploadImage = async (file: File): Promise<string> => {
    const m = await upload(file, p.creatorId);
    return `${m.cdn01}${m.image}`;
  };

  return {
    uploadImage,
  };
};
